import { p as proxyCustomElement, H, c as createEvent, h } from './index.js';
import { g as getValidityObject, c as checkValidity, r as reportValidity, s as setCustomValidity, a as setInputRef, b as getError, w as watchValue, d as watchError, e as watchWarning, f as renderFormField } from './p-Cg8AdZPK.js';
import { h as handleTabIndex } from './p-bL-8cS__.js';
import { d as defineCustomElement$5 } from './p-BbTg3Car.js';
import { d as defineCustomElement$4 } from './p-BlW2joRF.js';
import { d as defineCustomElement$3 } from './p-Dr61d_nc.js';
import { d as defineCustomElement$2 } from './p-_P4kPR3l.js';
import { d as defineCustomElement$1 } from './p-CdhcNtiX.js';

const radioButtonCss = ":host{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;box-sizing:border-box;display:inline-flex;flex:none;font-family:Open Sans;font-size:.875rem;font-weight:400;letter-spacing:-.0004em;line-height:1.25rem;line-height:normal;margin:0;max-width:100%;padding:0;width:fit-content}:host *,:host :after,:host :before{box-sizing:inherit}:host img{flex:none;overflow:hidden;text-overflow:ellipsis;white-space:pre-line}.inner{align-items:flex-start;display:flex;flex:1;gap:.5rem;height:100%;-webkit-user-select:none;user-select:none;width:100%}.inner,.input{cursor:pointer}.text{display:flex;flex-direction:column;justify-content:center;max-width:100%}:host([size=md]){--form-field--description-left:1.5rem}:host([size=md]) .label{align-items:center;color:var(--jw-theme-surface-text-default-color);display:inline-flex;font-family:Open Sans;font-size:.875rem;font-weight:400;gap:.5rem;letter-spacing:-.0004em;line-height:1.25rem;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}:host([size=md]) .description{color:var(--jw-theme-surface-text-description-color);font-family:Open Sans;font-size:.75rem;font-weight:400;letter-spacing:0;line-height:1rem}:host([size=md]:not([disabled]):focus) .input,:host([size=md]:not([disabled]):focus-visible) .input{outline:var(--jw-theme-effects-focus-default-outline)}:host([type=regular][size=lg]){flex:1;min-width:10rem}:host([type=regular][size=lg]) .inner{background-color:var(--jw-theme-form-field-default-bg-color);border:1px solid var(--jw-theme-form-border-regular-default-border-color);border-radius:.375rem;display:flex;gap:.75rem;padding:1rem}:host([type=regular][size=lg]) .text{gap:.125rem;text-wrap:pretty}:host([type=regular][size=lg]) .label{color:var(--jw-theme-surface-text-default-color);font-family:Open Sans;font-size:.875rem;font-weight:600;letter-spacing:-.0004em;line-height:1.25rem}:host([type=regular][size=lg]) .description{color:var(--jw-theme-surface-text-description-color);font-family:Open Sans;font-size:.75rem;font-weight:400;letter-spacing:0;line-height:1rem}:host([type=regular][size=lg][disabled]) .inner{background-color:var(--jw-theme-form-field-disabled-bg-color)}:host([type=regular][size=lg][disabled]) .label{color:var(--jw-theme-form-field-disabled-color)}:host([type=regular][size=lg][disabled]) .description{color:var(--jw-theme-form-field-disabled-color)}:host([type=regular][size=lg]:not([disabled])[checked]) .inner,:host([type=regular][size=lg]:not([disabled])[indeterminate]) .inner{background-color:var(--jw-theme-surface-level1-active-bg-color);border-color:var(--jw-theme-form-border-regular-focus-border-color)}:host([size=lg]:not([disabled])[checked]:hover) .inner,:host([size=lg]:not([disabled])[indeterminate]:hover) .inner{border-color:var(--jw-theme-form-border-regular-focus-border-color)}:host([type=regular][size=lg]:not([disabled]):hover) .inner{border-color:var(--jw-theme-form-border-regular-hover-border-color);box-shadow:var(--jw-theme-effects-shadow-shadow-md-box-shadow)}:host([type=regular][size=lg][error-type=error]) .inner{background-color:var(--jw-theme-error-muted-message-bg-color);border-color:var(--jw-theme-form-border-error-default-border-color)}:host([type=regular][size=lg][error-type=error]:hover) .inner{border-color:var(--jw-theme-form-border-error-hover-border-color)}:host([size=lg]:not([disabled]):focus) .inner,:host([size=lg]:not([disabled]):focus-visible) .inner{outline:var(--jw-theme-effects-focus-default-outline)}:host(:focus),:host(:focus-visible){outline:none}:host([disabled]) .inner,:host([disabled]) .input{cursor:not-allowed}:host([disabled]) .label{color:var(--jw-theme-form-field-disabled-color)}:host([disabled]) .description{color:var(--jw-theme-surface-text-disabled-color)}.input-container{display:flex;gap:1rem;padding:.125rem 0}.input{align-self:center;appearance:none;background-color:var(--jw-theme-form-field-default-bg-color);border-color:var(--jw-theme-form-border-regular-default-border-color);border-radius:50%;border-style:solid;border-width:1px;height:1rem;margin:0;outline:none;position:relative;width:1rem}.input:checked{background-color:var(--jw-theme-system-primary-default-bg-color);border-width:0;transition:border-color .38s cubic-bezier(.34,1.56,.64,1),background-color .38s cubic-bezier(.34,1.56,.64,1)}.input:checked:after{animation:uv068nk .38s cubic-bezier(.34,1.56,.64,1) forwards;background-color:var(--jw-theme-system-primary-default-color);border-radius:624.9375rem;content:\"\";height:100%;left:0;position:absolute;top:0;transform:translate(-50%,-50%);width:100%}@keyframes uv068nk{0%{transform:scale(1)}to{transform:scale(.42)}}.input:hover:not([disabled]){border-color:var(--jw-theme-form-border-regular-hover-border-color)}.input:hover:not([disabled]):checked{background-color:var(--jw-theme-system-primary-hover-bg-color);border-color:var(--jw-theme-system-primary-hover-bg-color)}.input[disabled]{background-color:var(--jw-theme-form-field-disabled-bg-color);border-color:var(--jw-theme-form-border-regular-default-border-color)}.input[disabled]:checked{background-color:var(--jw-theme-form-field-disabled-inverted-bg-color);color:var(--jw-theme-form-field-disabled-inverted-color)}:host(:focus) .input:checked{background-color:var(--jw-theme-system-primary-default-bg-color);border-color:var(--jw-theme-form-border-regular-focus-border-color);color:var(--jw-theme-system-primary-default-color)}:host(:focus) .input[disabled]:checked{background-color:var(--jw-theme-form-field-disabled-inverted-bg-color);color:var(--jw-theme-form-field-disabled-inverted-color)}:host(:hover) .input:hover{color:var(--jw-theme-system-primary-hover-color)}:host([error-type=error]) .input{border-color:var(--jw-theme-form-border-error-default-border-color)}:host([error-type=error]:hover) .input{border-color:var(--jw-theme-form-border-error-hover-border-color)}:host([size=lg]) .description{color:var(--jw-theme-surface-text-description-color);font-family:Open Sans;font-size:.75rem;font-weight:400;letter-spacing:0;line-height:1rem}:host([type=image]) .input{align-self:flex-start}:host([type=image]) img{max-height:2.5rem;max-width:2.5rem}:host([type=image]) .image-placeholder{background-color:#12151c;height:2.5rem;width:2.5rem}:host([type=image]) .inner{align-items:flex-start;gap:.5rem}:host([type=image]) .text{gap:.25rem}:host([type=image][disabled]) .label{color:var(--jw-theme-form-field-disabled-color)}:host([type=image][disabled]) .description{color:var(--jw-theme-surface-text-disabled-color)}:host([type=image][disabled]) .image-placeholder{background-color:#c0c8d8}:host([type=image]:not([disabled])[checked]) .image-placeholder{background-color:#055ffc}:host([type=image][error-type=error]) .description{color:var(--jw-theme-form-validation-error-color)}";

const WuiRadioButton = /*@__PURE__*/ proxyCustomElement(class WuiRadioButton extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.validityChecked = createEvent(this, "validityChecked", 7);
        this.validityReported = createEvent(this, "validityReported", 7);
        this.required = false;
        this.validity = getValidityObject();
        this.validationMessage = '';
        this.customValidation = undefined;
        this.checkValidity = checkValidity(this);
        this.reportValidity = reportValidity(this);
        this.setCustomValidity = setCustomValidity(this);
        this.showValidity = false;
        /**
         * For image radio, indicates if the src provided loaded correctly
         */
        this.srcError = false;
        this.setInputRef = setInputRef(this);
        this.dirty = false;
        this.getError = getError(this);
        //////// FORM FIELD END ////////
        //////// TAB FOCUSABLE START ////////
        this._tabIndex = 0;
        /**
         * Disabled state
         */
        this.disabled = false;
        /**
         * Sets checked display
         */
        this.checked = false;
        this.handleInput = (e) => {
            e.stopPropagation();
            if (this.disabled) {
                e.preventDefault();
                return;
            }
            // Radio button can only be checked, not unchecked
            this.checked = true;
            this.dirty = true;
            this.checkValidity();
            this.elm.dispatchEvent(new window.Event('input', { bubbles: true }));
        };
        this.handleSrcError = () => {
            this.srcError = true;
        };
    }
    _handleValueChange(newValue) {
        watchValue(this, newValue);
    }
    _watchError(...args) {
        watchError(this, ...args);
    }
    _watchWarning(...args) {
        watchWarning(this, ...args);
    }
    async _handleKeyDown(e) {
        if (e.key === 'Enter' || e.key === ' ') {
            const willCheck = !this.inputElm?.checked;
            // Forward event to hidden input
            this.inputElm?.click();
            // If the input was already checked, we shouldn't handle this event
            if (willCheck) {
                e.preventDefault();
                e.stopPropagation();
                return true;
            }
        }
    }
    componentWillRender() {
        handleTabIndex(this);
    }
    renderImage() {
        if (this.srcError || !this.imageSrc) {
            return h("div", { class: "image-placeholder" });
        }
        return h("img", { src: this.imageSrc, alt: this.imageAlt, onError: this.handleSrcError });
    }
    renderInner() {
        return (h("label", { class: "inner" }, h("div", { class: "input-container" }, typeof this.description === 'string' && typeof this.imageSrc === 'string' && this.renderImage(), h("input", { tabIndex: -1, class: "input", type: "radio", disabled: this.disabled, checked: this.checked, name: this.name, value: this.value, ref: this.setInputRef, onClick: this.handleInput, required: !!this.required,
            // Stop input and change events from propagation,
            // we'll handle click and fire our own input event
            onInput: (e) => {
                this.handleInput(e);
                e.stopPropagation();
            }, onChange: (e) => {
                e.stopPropagation();
            } })), (this.label || typeof this.description === 'string') && (h("div", { class: "text" }, this.label && h("span", { class: "label" }, this.label), typeof this.description === 'string' && h("div", { class: "description" }, this.description)))));
    }
    render() {
        return renderFormField(this, this.renderInner(), {
            host: {
                role: 'checkbox',
                'aria-checked': this.checked ? 'true' : 'false',
                type: typeof this.description === 'string' && typeof this.imageSrc === 'string' ? 'image' : 'regular',
                size: typeof this.size === 'string' ? this.size : typeof this.description === 'string' ? 'lg' : 'md',
            },
        });
    }
    get elm() { return this; }
    static get watchers() { return {
        "value": ["_handleValueChange"],
        "error": ["_watchError"],
        "warning": ["_watchWarning"]
    }; }
    static get style() { return radioButtonCss; }
}, [257, "wui-radio-button", {
        "value": [1025],
        "required": [8],
        "error": [8],
        "warning": [8],
        "validate": [16],
        "validity": [1040],
        "validationMessage": [1025, "validation-message"],
        "checkValidity": [16, "check-validity"],
        "reportValidity": [16, "report-validity"],
        "setCustomValidity": [16, "set-custom-validity"],
        "formField": [16, "form-field"],
        "name": [1],
        "label": [1],
        "description": [1],
        "size": [1],
        "imageSrc": [1, "image-src"],
        "imageAlt": [1, "image-alt"],
        "disabled": [516],
        "checked": [1540],
        "customValidation": [32],
        "showValidity": [32],
        "srcError": [32]
    }, [[0, "keydown", "_handleKeyDown"]], {
        "value": ["_handleValueChange"],
        "error": ["_watchError"],
        "warning": ["_watchWarning"]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-radio-button", "wui-box", "wui-form-field", "wui-icon", "wui-tooltip", "wui-tooltip-label"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-radio-button":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiRadioButton);
            }
            break;
        case "wui-box":
            if (!customElements.get(tagName)) {
                defineCustomElement$5();
            }
            break;
        case "wui-form-field":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "wui-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "wui-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
        case "wui-tooltip-label":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { WuiRadioButton as W, defineCustomElement as d };
